export default {
	data() {
		return {
			videoOpened: false
		};
	}
};
